/**
 *
 * Search Service Constants
 *
 */

import { SERVICE_NAMESPACE } from 'common';

export const URL = (apiUrl) => `${apiUrl}/evaluated_transfers`;

export const NAMESPACE = `${SERVICE_NAMESPACE}/search`;

// Trigger a fetch request in sagas
export const SEARCH_REQUEST = `${NAMESPACE}/SEARCH_REQUEST`;

export const UPDATE_ALREADY_REQUESTED_TRANSFER = `${NAMESPACE}/UPDATE_ALREADY_REQUESTED_TRANSFER`;

// Current status of the service
export const NOT_ASKED = `${NAMESPACE}/NOT_ASKED`;
export const LOADING = `${NAMESPACE}/LOADING`;
export const SUCCESS = `${NAMESPACE}/SUCCESS`;
export const FAILURE = `${NAMESPACE}/FAILURE`;

export const SEARCH_LIMIT = '1000';

export const TRANSFER_STATES = Object.freeze({
  transferStateReviewPending: 'ReviewPending',
  transferStateSuspended: 'Suspended',
  transferStateSuspendedPendingReturn: 'SuspendedPendingReturn',
  transferStateApproved: 'Approved',
  transferStateFundsPosted: 'FundsPosted',
  transferStatePositionPosted: 'PositionPosted',
  transferStateSentToBank: 'SentToBank',
  transferStateSentToRtpNetwork: 'SentToRtpNetwork',
  transferStateCompleted: 'Completed',
  transferStatePaymentScheduled: 'PaymentScheduled',
  transferStateRejectedFundsNotPosted: 'RejectedFundsNotPosted',
  transferStateRejectedPositionNotPosted: 'RejectedPositionNotPosted',
  transferStatePendingPrinting: 'PendingPrinting',
  transferStateRejectedNotSentToBank: 'RejectedNotSentToBank',
  transferStateRejectedUnapproved: 'RejectedUnapproved',
  transferStateRejectedValidationFailed: 'RejectedValidationFailed',
  transferStateSendToBankFailed: 'SendToBankFailed',
  transferStateFundsReturned: 'FundsReturned',
  transferStateReturnedWaitingForReversal: 'ReturnedWaitingForReversal',
  transferStatePostponed: 'Postponed',
  transferStateReturned: 'Returned',
  transferStateCanceled: 'Canceled',
  transferStateStoppedPayment: 'StoppedPayment',
  transferStateFailedAtBank: 'FailedAtBank',
  transferStateVoided: 'Voided',
  transferStateFailedToSuspend: 'FailedToSuspend',
  transferStatePayPalReviewPending: 'PayPalReviewPending',
  transferStateInvestorReviewPending: 'InvestorReviewPending',
});

export const TRANSFER_DIRECTIONS = Object.freeze({
  transferDirectionWithdrawal: 'WITHDRAWAL',
  transferDirectionDeposit: 'DEPOSIT',
  transferDirectionJournal: 'JOURNAL',
});

export const TRANSFER_MECHANISMS = Object.freeze({
  transferMechanismAch: 'ACH',
  transferMechanismWire: 'WIRE',
  transferMechanismCheck: 'CHECK',
});

export const TRANSFER_REVIEW_ROLES_PARTIAL = Object.freeze({
  transferReviewRoleMyQueue: 'ASSIGNED',
});

export const TRANSFER_REVIEW_ROLES = Object.freeze({
  ...TRANSFER_REVIEW_ROLES_PARTIAL,
  transferReviewRoleMyRole: 'ACTIONABLE',
});

export const FED_REFERENCE_NUMBER_TYPES = Object.freeze({
  FEDWIRE: 'FED',
  BNY_MELLON: 'BNY',
});



// WEBPACK FOOTER //
// ./src/services/search/constants.js